export default "__VITE_ASSET__B3FOLJAd__"